
function nl2br (str, is_xhtml=true) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}
window.nl2br = nl2br;

function is_empty(obj) {
    if (typeof (obj) == 'undefined' || obj == null || obj.trim() == "")
        return true;
    else return false;
}
window.is_empty = is_empty;

function is_null(obj) {
    if (typeof (obj) == 'undefined' || obj == null)
        return true;
    else return false;
}
window.is_null = is_null;


function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
window.isFunction = isFunction;


function is_object(obj) {
    if ((typeof (obj) == 'object') && (typeof (obj) != 'undefined') && (obj != null))
        return true;
    else return false;
}
window.is_object = is_object;


function scroll_to(target) {
    switch (target) {
        case 0 :
        case 'top' :
            window.scrollTo(0, 0);
            break;
        case 1 :
        case 'bottom' :
            window.scrollTo(0, document.body.scrollHeight);
            break;
        default:
            $([document.documentElement, document.body]).animate({ scrollTop: target.offset().top }, 2000);
            break;
    }
}
window.scroll_to = scroll_to;

function getQueryVariable(variable) {
    var query = window.location.search.substring(1); // 移除問號
    var vars = query.split("&"); // 分割多個參數
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}
window.getQueryVariable = getQueryVariable;


function convertHTMLEntity(text){
    const span = document.createElement('span');

    return text.replace(/&[#A-Za-z0-9]+;/gi, (entity,position,text)=> {
        span.innerHTML = entity;
        return span.innerText;
    });
}

function copy_to_clipboard(div) {

    let div_id = "#" + div;
    let range = $(div_id);
    let text = range.html();
    text = convertHTMLEntity(text);

	// navigator clipboard 需要https等安全上下文
	if (navigator.clipboard && window.isSecureContext) {
		// navigator clipboard 向剪贴板写文本
		navigator.clipboard.writeText(text).then(function() {
	        // alert("复制成功");
            console.log('Copied to clipboard Succeaa.')
	    }, function() {
	        // alert("复制失败");
            console.log('Copied to clipboard Fail.');
	    });
	}
}
window.copy_to_clipboard = copy_to_clipboard;


(function($)
{
    jQuery.fn.setfocus = function()
    {
        return this.each(function()
        {
            var dom = this;
            setTimeout(function()
            {
                try { dom.focus(); } catch (e) { } 
            }, 0);
        });
    };
})(jQuery);

$("#ERP_SEARCH [name='target']").on('keypress',function(e) {
    if(e.which == 13) {
        ERP_search();
    }
});
